import { useState, useCallback } from 'react';

export function useForceRerender() {
  const [, setValue] = useState(0); // integer state
  const cb = useCallback(() => setValue(v => ++v), [setValue]);
  return cb;
}
